import {
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import SponsorDisabilityPrefillInfo from '../../components/FormDescriptions/SponsorDisabilityPrefillInfo';
import { DEFAULT_TITLE_OPTS, titleWithRoleUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['eligibility--disability-title'];
const INPUT_LABEL = content['eligibility--disability-label--self'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.sponsor),
    'ui:description': SponsorDisabilityPrefillInfo,
    'view:sponsorIsDisabled': yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['view:sponsorIsDisabled'],
    properties: {
      'view:sponsorIsDisabled': yesNoSchema,
    },
  },
};
